export default "__VITE_ASSET__BFvNUXmB__"